import { lighten, makeStyles } from '@material-ui/core/styles';

import 'roboto-fontface/css/roboto/roboto-fontface.css';
import 'material-design-icons/iconfont/material-icons.css';

/**
 * Global styles only.  Component-specific styles should be defined in a component-specific file.
 */
const useStyles = makeStyles((theme) => ({
    '@global': {
        'html, body': {
            height: '100%',
            // Needed to ensure background colors are printed in PDF reports.
            '-webkit-print-color-adjust': 'exact',

            '@media print': {
                height: 'auto',
            },
        },
        body: {
            margin: 0,
            padding: 0,
            minHeight: '100%',
            overflow: 'hidden',
            fontFamily: 'Roboto, Helvetica, Arial, Verdana, sans-serif',
            color: theme.palette.text.primary,

            '@media print': {
                minHeight: 'auto',
                overflow: 'inherit',
            },

            '& .MuiInputLabel-root.Mui-focused': {
                color: theme.palette.type === 'light' ? theme.palette.primary.main : theme.palette.primary.light,
            },
            '& .MuiInput-underline:after': {
                borderBottomColor:
                    theme.palette.type === 'light' ? theme.palette.primary.main : theme.palette.primary.light,
            },

            // For Safari issue causing css not to be applied: https://github.com/mui-org/material-ui/issues/26251, can be removed once Safari fixes their issue
            '& .MuiButton-root': {
                transition: 'color .01s',
            },

            ...(theme.palette.type === 'dark'
                ? {
                      '& *': {
                          scrollbarColor: 'dark',
                      },

                      '& *::-webkit-scrollbar': {
                          height: 12,
                          width: 12,
                          background: lighten(theme.palette.background.paper, 0.02),
                      },

                      '& *::-webkit-scrollbar-thumb': {
                          background: lighten(theme.palette.background.paper, 0.15),
                          '-webkit-border-radius': '1ex',
                          '-webkit-box-shadow': '0px 1px 2px rgba(0, 0, 0, 0.75)',
                      },

                      '& *::-webkit-scrollbar-corner': {
                          background: lighten(theme.palette.background.paper, 0.02),
                      },
                  }
                : {}),
        },
        a: {
            textDecoration: 'none',
            color: theme.palette.type === 'light' ? theme.palette.primary.main : theme.palette.primary.light,
            whiteSpace: 'nowrap',
            fontWeight: 500,

            '&:hover': {
                textDecoration: 'underline',
            },

            '@media print': {
                color: theme.palette.text.primary,
                fontWeight: 'inherit',
            },
        },
        '.app-root': {
            height: '100%',
        },
        '.flex-container, .scroll-container': {
            ...theme.mixins.flex.displayFlex,
            ...theme.mixins.flex.flexDirectionColumn,
            ...theme.mixins.flex.grow(1),
            minHeight: 0,
        },
        '.scroll-container': {
            overflow: 'auto',
        },
    },
}));

export default useStyles;
